module.exports = __webpack_public_path__ + "img/iconNo16.d777b6cf.png";